<div class="container mx-auto mt-5 px-4">
  <h2 class="text-3xl font-semibold text-center my-5">Evaluaciones</h2>

  <div class="flex justify-between items-center mb-4">
    <button (click)="volver()" class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded">Volver</button>
    <button
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      (click)="crearEvaluacion()"
    >
      Registrar Evaluación
    </button>
  </div>
  <app-table
    [data]="evaluaciones"
    [columns]="columns"
    [actions]="actions"
    searchPlaceholder="Buscar evaluacion..."
  ></app-table>

  <app-item-modal
    [isOpen]="showModal"
    [item]="selectedItem"
    [title]="'Editar Evaluación'"
    [fields]="fields"
    (close)="showModal = false"
    (save)="saveChanges($event)"
  ></app-item-modal>
</div>
